import { v4 } from 'uuid'

import { FormItemDraggableBase } from './form-item-draggable-base'
import { IconEnum } from '../../../../../assets/icons'
import { FormItemType } from '../../constants/form-builder.constants'

export const HeaderDraggable = () => {
  const id = v4()
  const type = FormItemType.Header

  return (
    <FormItemDraggableBase
      icon={IconEnum.Header}
      id={id}
      title="formBuilder.header"
      type={type}
    />
  )
}
